import { createBrowserRouter } from "react-router-dom"
import Players from "./modules/players/Players"
import Player from "./modules/player/Player"
import PlayLogs from "./modules/playLogs/PlayLogs"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Players />,
  },
  {
    path: "/:id",
    element: <Player />,
  },
  {
    path: "/:id/play-logs",
    element: <PlayLogs />,
  },
])
